import React from "react";
import { Check } from "lucide-react";
import PayPalSubscribeButton from "@/components/PayPalSubscribeButton";

const STANDARD = process.env.REACT_APP_PAYPAL_PLAN_ID;
const UNLIMITED = process.env.REACT_APP_PAYPAL_PLAN_UNLIMITED;

const PLANS = [
    { tier: "standard", planId: STANDARD, title: "Basic", price: "$20",
      tagline: "Up to 5 outings every month", popular: false,
      intro: "$0 today — free for your first 30 days.",
      disclosure: "$0 due today. Your first 30 days are free and include 5 outings. Unless canceled or upgraded, your Basic membership automatically renews at $20/month for up to five outings per month after the free period.",
      features: ["Free 30-day trial (5 outings)", "Then up to 5 outings / month", "Verified members only", "Private group chats"] },
    { tier: "unlimited", planId: UNLIMITED, title: "Unlimited", price: "$50",
      tagline: "Unlimited outings every month", popular: true,
      intro: "Billed $50/month — cancel anytime.",
      disclosure: "$50 is billed today and every month. Includes unlimited activity opportunities, subject to availability and participation requirements. Cancel anytime.",
      features: ["Unlimited outings", "Verified members only", "Private group chats", "Priority on popular activities"] },
];

// Renders both membership options, each with its own PayPal subscribe button.
export default function MembershipPlans({ onPaid, only }) {
    const plans = only ? PLANS.filter((p) => p.tier === only) : PLANS;
    return (
        <div className={`grid gap-4 ${plans.length > 1 ? "sm:grid-cols-2" : ""}`} data-testid="membership-plans">
            {plans.map((p) => (
                <div key={p.tier} data-testid={`plan-card-${p.tier}`}
                    className={`relative rounded-2xl bg-card p-5 shadow-sm ring-1 ${p.popular ? "ring-2 ring-accent" : "ring-black/5"}`}>
                    {p.popular && <span className="absolute -top-3 left-5 rounded-full bg-accent px-3 py-0.5 text-xs font-700 text-accent-foreground">Most popular</span>}
                    <div className="flex items-baseline justify-between">
                        <h3 className="font-display text-lg font-700 text-primary">{p.title}</h3>
                        <p className="font-display text-2xl font-700 text-primary">{p.price}<span className="text-sm text-muted-foreground">/mo</span></p>
                    </div>
                    <p className="mt-1 text-sm text-muted-foreground">{p.tagline}</p>
                    <p className="mt-1 text-sm font-700 text-accent">{p.intro}</p>
                    <ul className="mt-3 space-y-1.5">
                        {p.features.map((f) => (
                            <li key={f} className="flex items-center gap-2 text-sm text-foreground"><Check className="h-4 w-4 text-accent" /> {f}</li>
                        ))}
                    </ul>
                    <p className="mt-4 rounded-lg bg-secondary/60 p-2.5 text-[11px] leading-relaxed text-muted-foreground" data-testid={`plan-disclosure-${p.tier}`}>
                        {p.disclosure}
                    </p>
                    <div className="mt-3 rounded-xl bg-white p-3 shadow-inner ring-1 ring-black/5">
                        <PayPalSubscribeButton planId={p.planId} tier={p.tier} onApproved={onPaid} />
                    </div>
                </div>
            ))}
        </div>
    );
}
